module.exports = __webpack_public_path__ + "img/SES_235110005.afcd3046.jpg";